import { FunctionsDiscountCodeApplyEvent, MRCustomEventTypes } from './types';

export function sendFunctionsDiscountCodeAppliedEvent(mrCart: any) {
  const event = new CustomEvent('mrCustomEvent', {
    detail: {
      requestType: MRCustomEventTypes.FUNCTIONS_DISCOUNT_CODE_APPLY,
      mrCart,
    } as FunctionsDiscountCodeApplyEvent,
  });
  document.dispatchEvent(event);
}
